export default __webpack_public_path__ + "static/media/basic.0c51e3ae.png";